import React, { useEffect, useState } from "react";
import ProductCard from "./ProductCard";
import {
} from "../../../assets/images";
import axios from "axios";

const DiscountProductsKampaniya = () => {
  const [list, setItems] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    getProducts();
  }, []);

  const getProducts = async () => {
    try {
      const response = await axios.get(
        `https://www.elzabeauty.az/elza/dashboard.php`,
        { withCredentials: false }
      );

      // Hem discount > 0 hem de discountSituation === 1 olanları filtrele
      const filteredProducts = response.data.data.filter(
        (product) => product.discount > 0 && product.discountSituation === 1
      );

      // İlk 5 ürünü seç
      const limitedData = filteredProducts.slice(0, 5);

      setItems(limitedData);
      setIsLoading(false);
    } catch (error) {
      console.error("Error fetching products:", error);
    }
  };

  if (isLoading) {
    return <p className="text-center text-[white]">Loading...</p>;
  }

  return (
    <div className="pt-10 ">
      <div className="max-w-containerSm md:max-w-container mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
          {list.map((product) => {
            return (
              <ProductCard
                id={product.id}
                name={product.name}
                nameEn={product.nameEn}
                description={product.description}
                descriptionEn={product.descriptionEn}
                information={product.information}
                informationEn={product.informationEn}
                isNew={product.isNew}
                isBestseller={product.isBestseller}
                discount={product.discount}
                discountSituation={product.discountSituation}
                image1={product.image1}
                image2={product.image2}
                image3={product.image3}
                image4={product.image4}
                image5={product.image5}
              />
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default DiscountProductsKampaniya;
